export enum Color {
    Black = '#131515',

    Grey1 = '#4e5656',
    Grey2 = '#6b7676',
    Grey3 = '#8c9595',
    Grey4 = '#a9afaf',
    Grey5 = '#c2c6c6',
    Grey6 = '#d2d6d6',
    Grey7 = '#dcdfdf',
    Grey8 = '#e5e6e6',
    Grey9 = '#edeeee',
    Grey10 = '#fafbfb',

    White = '#ffffff',

    Turquoise1 = '#004f5d',
    Turquoise2 = '#056a81',
    Turquoise3 = '#158b9f',
    Turquoise4 = '#2caabb',
    Turquoise5 = '#6dd4db',
    Turquoise6 = '#9de9ee',
    Turquoise7 = '#ccf1f1',
    Turquoise8 = '#e4f9f9',
    Turquoise9 = '#eaf8fb',

    LightTurquoise1 = '#f5fbfc',
    LightTurquoise2 = '#ccdcdf',

    DarkOrange1 = '#d92c0a',

    Orange1 = '#f35c3e',
    Orange2 = '#f67358',
    Orange3 = '#ff9c88',
    Orange4 = '#f9c3b8',
    Orange5 = '#fddad3',
    Orange6 = '#ffebe8',
    Orange7 = '#fff7f5',
    Orange8 = '#fffcfb',

    TrueOrange1 = '#ff8814',
    TrueOrange2 = '#ffbc7a',
    TrueOrange3 = '#ffd6ae',
    TrueOrange4 = '#ffefe0',

    DarkYellow1 = '#d49f00',

    Yellow1 = '#ffcd36',
    Yellow2 = '#ffe186',
    Yellow3 = '#ffecb0',
    Yellow4 = '#fdf7e6',

    DarkBlue1 = '#5a83be',

    Blue1 = '#6e9de1',
    Blue2 = '#99baea',
    Blue3 = '#d3e1f6',
    Blue4 = '#f0f5fc',

    DarkGreen1 = '#15a480',

    Green1 = '#40c695',
    Green2 = '#9cf0d2',
    Green3 = '#cdf5eb',
    Green4 = '#e0f9f3',
    Green5 = '#23aa88',

    BrightGreen1 = '#19e9b4',

    TrueGreen1 = '#79de95',
    TrueGreen2 = '#a4e2bf',
    TrueGreen3 = '#caf0db',
    TrueGreen4 = '#e5fcef',

    YellowGreen1 = '#b0ea89',
    YellowGreen2 = '#c9f2ae',
    YellowGreen3 = '#e2f4d6',
    YellowGreen4 = '#f1fdea',

    YellowOrange1 = '#ffab2e',
    YellowOrange2 = '#ffc36a',
    YellowOrange3 = '#fbdaa9',
    YellowOrange4 = '#ffeed4',

    RedOrange1 = '#f47130',
    RedOrange2 = '#ff915a',
    RedOrange3 = '#ffc0a0',
    RedOrange4 = '#ffe2d3',

    Purple1 = '#c596ea',
    Purple2 = '#d9b7f4',
    Purple3 = '#ecd8fc',
    Purple4 = '#f6ebff',

    Pink1 = '#ed83b0',
    Pink2 = '#fda5eb',
    Pink3 = '#ffd1e5',
    Pink4 = '#ffe4f0',

    Primary = Turquoise2,
    Danger = Orange1,
    Warning = Yellow1,
    Success = Green1,
    Info = Blue1,

    Disabled = '#b3b4b4',
    Border = Grey7,
    LinkColor = Turquoise3,
    NoData = Grey5,
}

export enum ScoreColor {
    Excellent = Color.Green1,
    Good = Color.YellowGreen1,
    Average = Color.Yellow1,
    Fair = Color.TrueOrange1,
    Poor = Color.Orange1,
    NoData = Color.NoData,
}

export enum RepScoreColor {
    Best = Color.Green1,
    Better = Color.TrueGreen1,
    Good = Color.YellowGreen1,
    Average = Color.Yellow1,
    Fair = Color.YellowOrange1,
    Bad = Color.TrueOrange1,
    Worse = Color.RedOrange1,
    Worst = Color.Orange1,
    NoData = Color.NoData,
}

export enum SentimentColor {
    Positive = Color.Green1,
    Neutral = Color.DarkYellow1,
    Negative = Color.Orange1,
    None = Color.NoData,
    Other = Color.Blue1,
}

export const FontFamily = 'Inter';

/** colorFull to be used for rating that sits alongside sentiment buckets */
export const SentimentRatingColor = Color.YellowOrange1;

export const ChartColorPalette = [
    Color.Turquoise1,
    Color.Grey4,
    Color.DarkBlue1,
    Color.Green1,
    Color.Turquoise3,
    Color.Grey2,
    Color.Blue1,
    Color.DarkGreen1,
    Color.DarkOrange1,
    Color.Yellow1,
    Color.Orange2,
    Color.DarkYellow1,
    Color.Turquoise5,
    Color.Grey8,
    Color.Blue2,
    Color.Green3,
    Color.Turquoise7,
    Color.Grey6,
    Color.Blue3,
    Color.Green2,
    Color.Orange3,
    Color.Yellow3,
    Color.Orange5,
    Color.Yellow2,
];
